<template>
  <div>
    <ContentHeader :material-nav="false" :show-back="false"/>
    <div class="content-container">
      <div class="menu-container">
        <el-card>
          <div class="el-icon-circle-check"></div>
          <div class="order-success-title">{{  $route.query.isMore ? '在线申报成功':'订单提交成功'}}</div>
          <div class="order-success-code" v-if="!$route.query.isMore">订单编号：{{ $route.query.orderNumber }}</div>
          <el-button type="danger" class="to-index-btn" @click="toMaterialIndex">进入POCM订购首页</el-button>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import ContentHeader from '../../components/content-header'
export default {
  name: 'non-menu',
  components: {
    ContentHeader
  },
  methods: {
    toMaterialIndex () {
      this.$router.push({ name: 'material-index' })
    },
    viewOrder () {
      this.$router.push({ name: 'order-list-menu' })
    }
  }
}
</script>

<style lang="scss" scoped>
.menu-container {
  display: flex;
  justify-content: center;
  font-size: 24px;
  color: $base-black;
  .el-card {
    width: 100%;
    height: 300px;
    text-align: center;
    .el-icon-circle-check {
      line-height: 100px;
      font-size: 50px;
      color: $base-red;
    }
    .order-success-title {
      padding-bottom: 10px;
    }
    .order-success-code {
      font-size: 14px;
      color: #666;
    }
    .el-button {
      margin-right: 10px;
      margin-top: 30px;
    }
  }
}
</style>
